module.exports = __webpack_public_path__ + "ColabBol.5bead7894a576df8c03b.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/colaborate/ColabBol.woff
// module id = ../../../../../src/assets/font/colaborate/ColabBol.woff
// module chunks = 2